import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaVoidDefinition } from './TypedDefinition'

export const SchemaVoidPlugin = createSchemaPlugin(
  'Schema.Void',
  SchemaVoidDefinition
)
